import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SpeakerSliceState = {
  shots: Record<string, any>;
};

const initialState: SpeakerSliceState = {
  shots: {}
};

const SpeakerSlice = createSlice({
  name: 'speakers',
  initialState: initialState,
  reducers: {
    addSpeakers: (state, action: PayloadAction<{ shotId: string; speakerData: any }>) => {
      const { shotId, speakerData } = action.payload;
      state.shots[shotId] = speakerData; // Add speaker to the shots object using shotId as the key
    }
  }
});
export const getSpeaker = (state: SpeakerSliceState, shotId: string): any | null => {
  return state.shots[shotId as string] || null; // Returns speaker data or null if not found
};

export const { addSpeakers } = SpeakerSlice.actions;
export const SpeakerReducers = SpeakerSlice.reducer;
